import { FC } from "react";
import { StatCoachDto } from "../../../../types/stats";
import { getStaticUrl, getWordEnding } from "../../../../utils";
import { motion } from "framer-motion";

interface CoachProps extends StatCoachDto { }

export const CoachCard: FC<CoachProps> = ({
    name,
    wins,
    draws,
    losses,
    winStreak,
    noLossStreak,
    //firstMatch,
    //lastMatch,
    photoUrl,
    firstMatchData,
    lastMatchData,
}) => {
    const winsPecentage = ((wins / (wins + draws + losses)) * 100).toFixed(2);

    const firstMatch = <a href={firstMatchData.url} className="hover:no-underline hover:opacity-90">{firstMatchData.name}</a>;
    const lastMatch = <a href={lastMatchData.url} className="hover:no-underline hover:opacity-90">{lastMatchData.name}</a>;

    return (
        <div className="relative font-semibold box-border transition-all flex flex-col sm:flex-row justify-between opacity-95 hover:opacity-100 items-center sm:gap-4 border border-solid border-slate-200 sm:border-0 sm:border-b sm:border-b-slate-100 hover:bg-sky-100/25 hover:scale-105 pb-28 sm:pb-0 sm:pt-4 px-2 sm:px-8 rounded-2xl max-w-full sm:max-w-5xl w-full">
            <h2 className="sm:hidden text-3xl text-sky-950 py-2">{name}</h2>
            <motion.div
                initial={{ opacity: 0, x: -100 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5 }}
                className="text-center self-end sm:pl-8"
            >
                <img src={getStaticUrl(photoUrl)} alt={name} className="w-full sm:w-80" />
            </motion.div>
            <motion.div
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5 }}
                className="hidden sm:block pl-16 pb-4 w-2/3 text-3xl font-medium text-sky-950"
            >
                <h2 className="text-5xl text-sky-950">{name}</h2>
                <div className="flex flex-col gap-4 pt-12">
                    <div>Побед: {winsPecentage}%</div>
                    <div>Победная серия: {winStreak} {getWordEnding(winStreak, ['матч', 'матча', 'матчей'])}</div>
                    <div>Беспроигрышная серия: {noLossStreak} {getWordEnding(noLossStreak, ['матч', 'матча', 'матчей'])}</div>
                    <div>Первый матч: {firstMatch}</div>
                    <div>Последний матч: {lastMatch}</div>
                </div>
            </motion.div>
            <div className="sm:hidden w-full absolute bottom-0 flex flex-col text-white bg-sky-950/90 rounded-2xl font-normal overflow-hidden">
                <div className="p-2">
                    <div className="flex flex-row justify-between"><span>Побед:</span> <span className="font-semibold">{winsPecentage}%</span></div>
                    <div className="flex flex-row justify-between"><span>Победная серия:</span> <span className="font-semibold">{winStreak} {getWordEnding(winStreak, ['матч', 'матча', 'матчей'])}</span></div>
                    <div className="flex flex-row justify-between"><span>Беспроигрышная серия:</span> <span className="font-semibold">{noLossStreak} {getWordEnding(noLossStreak, ['матч', 'матча', 'матчей'])}</span></div>
                </div>
                <div className="bg-sky-950 p-2 border-t border-solid border-t-white">
                    <div className="text-center">Первый матч:<br /><span className="font-semibold">{firstMatch}</span></div>
                    <div className="text-center">Последний матч:<br /><span className="font-semibold">{lastMatch}</span></div>
                </div>
            </div>
        </div>
    );
};